import { useEffect, useState } from "react";
import { api, todayYMD } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { PageLoader } from "@/components/PageLoader";

export default function AdminAbsen() {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState(todayYMD());
  const [inT, setInT] = useState("08:00");
  const [outT, setOutT] = useState("17:00");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/users")
      .then((r) => setUsers(r.data.filter((u) => u.role === "pegawai")))
      .finally(() => setLoading(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!userId) return toast.error("Pilih pegawai");
    setBusy(true);
    try {
      await api.post("/admin/attendance", {
        user_id: userId,
        work_date: date,
        in_time: inT || null,
        out_time: outT || null,
      });
      toast.success("Presensi diset");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-2xl mx-auto">
      <p className="overline">Manual</p>
      <h1 className="font-display text-3xl font-bold tracking-tight">Absenkan Pegawai</h1>
      <p className="text-sm text-zinc-500 mt-1">Set presensi manual untuk pegawai (override/keep).</p>

      {loading ? <PageLoader label="Memuat..." /> : (
      <Card className="mt-6 p-6 border border-zinc-200 shadow-none">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Pegawai</Label>
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger className="mt-1" data-testid="abs-user"><SelectValue placeholder="Pilih pegawai" /></SelectTrigger>
              <SelectContent>
                {users.map((u) => (
                  <SelectItem key={u.id} value={u.id}>{u.name} ({u.employee_id})</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Tanggal</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1" data-testid="abs-date" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Jam Masuk (kosong = skip)</Label>
              <Input type="time" value={inT} onChange={(e) => setInT(e.target.value)} className="mt-1" data-testid="abs-in" />
            </div>
            <div>
              <Label>Jam Pulang (kosong = skip)</Label>
              <Input type="time" value={outT} onChange={(e) => setOutT(e.target.value)} className="mt-1" data-testid="abs-out" />
            </div>
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary/90" data-testid="btn-abs-save">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Simpan Presensi"}
          </Button>
        </form>
      </Card>
      )}
    </div>
  );
}
